export default __webpack_public_path__ + "static/media/c-sharp-c-logo-02F17714BA-seeklogo.com.7f58ab59.png";